import { useRouter } from 'next/router';
import { memo, useCallback, useContext } from "react";
import styles from "./index.module.scss";

import { useAppContext } from "context/state";

import { UPLOAD_BASE_URL } from "api/routes";
import MainFormContext from "context/main-form";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import Image from "next/image";
import { addThumbnailPostfixToImageName } from "utils/general";

import FormStepFour from "./four";
import FormLocationStep from "./location";
import FormProjectTypeStep from "./project-type";
import FormUserStep from "./user";



function MainFormSteps() {
    const { formConfigs } = useAppContext()

    const { values } = useContext(MainFormContext)

    const router = useRouter()

    dayjs.extend(isToday);


    // return step component base on current state
    const stepComponents = useCallback((step: number) => {
        switch (step) {
            case 0: {
                return <FormLocationStep />
            }
            case 1: {
                return <FormUserStep />
            }
            case 2: {
                // this message props it's for cabinet-ads-landing page
                // it show a success message on after submit project information
                return (
                    <>
                        {
                            values?.messages &&
                            <p className={styles.success_message}>
                                درخواست شما با موفقیت ثبت شد. لطفا برای خدمت رسانی بهتر با پاسخ به سوالات زیر
                                اطلاعات کاملتری در مورد پروژه خودتون در اختیار ما قرار بدین
                            </p>
                        }
                        <FormProjectTypeStep />
                    </>
                )
            }
            case 3: return <FormStepFour />

            default: {
                return <>مشکلی بوجود آمده است، لطفا صفحه را رفرش کنید</>
            }
        }
    }, [values.step])






    return (
        <section
            className={styles.steps + ` flex flex-column align-i-center jcb gap-15 ${formConfigs.config?.includes("productPage") ? styles.prod_page : ''}`}
        >

            <div className={styles.content__steps}>
                {
                    router.query?.avatar &&
                    <div className={styles.avatar__components}>
                        <Image
                            src={
                                UPLOAD_BASE_URL +
                                addThumbnailPostfixToImageName(router.query.avatar)
                            }
                            alt="avatar"
                            width={70}
                            height={70}
                            objectFit="cover"
                        />
                    </div>
                }

                { // return some step component base on current state
                    stepComponents(values.step)
                }
            </div>
        </section>
    )
}

export default memo(MainFormSteps)